import { mutations as MUTATION, actions as ACTION } from "./types";
import { Api, ApiUrl } from "../../services";
import i18n, { loadLanguageAsync } from "@/i18n";
import Cookie from "@/utils/cookie";
import { GEM_LANG_COOKIE_NAME } from "@/config/constants/common";
import { checkKeyValid } from "@/utils/globalConfigs";
import { connectPlatformV7, getShopV7Api, initGemPages} from "@/services/instantApi";

// const timeAgo = time => {
//   switch (typeof time) {
//     case "number":
//       break;
//     case "string":
//       time = +new Date(time);
//       break;
//     case "object":
//       if (time.constructor === Date) time = time.getTime();
//       break;
//     default:
//       time = +new Date();
//   }
//   var time_formats = [
//     [60, "seconds", 1], // 60
//     [120, "1 minute ago", "1 minute from now"], // 60*2
//     [3600, "minutes", 60], // 60*60, 60
//     [7200, "1 hour ago", "1 hour from now"], // 60*60*2
//     [86400, "hours", 3600], // 60*60*24, 60*60
//     [172800, "Yesterday", "Tomorrow"], // 60*60*24*2
//     [604800, "days", 86400], // 60*60*24*7, 60*60*24
//     [1209600, "Last week", "Next week"], // 60*60*24*7*4*2
//     [2419200, "weeks", 604800], // 60*60*24*7*4, 60*60*24*7
//     [4838400, "Last month", "Next month"], // 60*60*24*7*4*2
//     [29030400, "months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
//     [58060800, "Last year", "Next year"], // 60*60*24*7*4*12*2
//     [2903040000, "years", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
//     [5806080000, "Last century", "Next century"], // 60*60*24*7*4*12*100*2
//     [58060800000, "centuries", 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
//   ];
//   var seconds = (+new Date() - time) / 1000,
//     token = "ago",
//     list_choice = 1;
//   if (seconds == 0) {
//     return "Just now";
//   }
//   if (seconds < 0) {
//     seconds = Math.abs(seconds);
//     token = "from now";
//     list_choice = 2;
//   }
//   var i = 0,
//     format;
//   while ((format = time_formats[i++]))
//     if (seconds < format[0]) {
//       if (typeof format[2] == "string") return format[list_choice];
//       else return Math.floor(seconds / format[2]) + " " + format[1] + " " + token;
//     }
//   return time;
// };

const actions = {
  [ACTION.ACCOUNT_UPDATE_SHOP_INFO]: async (store, { data, onSuccess, onError }) => {
    Api.base.put(ApiUrl.base.account.updateAccount, data)
      .then(() => {
        store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, {
          success: true
        });
        store.commit(MUTATION.ACCOUNT_UPDATE_SHOP_INFO, data);
        setTimeout(() => {
          store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, { success: false });
        }, 2000);
        if (onSuccess && typeof onSuccess == "function") {
          onSuccess();
        }
      })
      .catch(err => {
        if (onError && typeof onError == "function") {
          onError(err);
        }
        store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, {
          error: true
        });
        setTimeout(() => {
          store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, { error: false });
        }, 2000);
        // eslint-disable-next-line no-console
        console.error(err)
      });
  },
  [ACTION.ACCOUNT_UPDATE_STORE_INFO]: async (store, { data }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.put(ApiUrl.base.account.updateStore, data);
        // eslint-disable-next-line no-console
        console.log(res);
        store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, {
          success: true
        });
        store.commit(MUTATION.ACCOUNT_UPDATE_SHOP_INFO, data);
        setTimeout(() => {
          store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, { success: false });
        }, 2000);
        resolve(data);
      } catch (error) {
        store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, {
          error: true
        });
        setTimeout(() => {
          store.commit(MUTATION.ACCOUNT_UPDATE_STATUS, { error: false });
        }, 2000);
        reject(error);
      }
    });
  },
  [ACTION.ACCOUNT_WHO_AM_I]: async (
    store,
    { onSuccess, onError, sharedId, getGA, getSurvey, isLoading } = {
      info: undefined,
      onSuccess: undefined,
      onError: undefined,
      sharedId: undefined,
      isLoading: true
    }
  ) => {
    const state = store.state;
    state.status.loading = isLoading;
    try {
      let params = {
        "account_info": true,
        "store_info": true,
        "global_configs": true,
      };
      if (sharedId != undefined && sharedId != null) {
        params.code = sharedId;
      }
      if (typeof getGA != "undefined") {
        params = {...params, ...{ ga: true }}
      }
      if (typeof getSurvey != "undefined") {
        params = {...params, ...{ survey: true }}
      }

      let res;
      let flagCheckParam = false;
      // Thêm để hạn chế load api/me 2 lần
      if(window.__firstLoadMe && window.__firstLoadMeParams){

        flagCheckParam = true;
        window.__firstLoadMe = false;
        // Kiểm tra xem có thiếu param hay không
        for (const key in params) {
          if( window.__firstLoadMeParams.indexOf(key) === -1){
            flagCheckParam = false;
            break;
          }
        }
      }

      if(flagCheckParam){
        // hotfix để api me chỉ gọi 1 lần
        const callbackAPIMe = function(data){
          if (data && !["401", 401, "error"].includes(data.status)) {
            const shop = data.data;

            if(process.env.VUE_APP_OVERWRITE_DEVELOPMENT_STORE === "true") shop.developmentStore = false;

            store.commit(MUTATION.ACCOUNT_ATTACH, shop);

            if (onSuccess) onSuccess(data);
            state.status.loading = false;
          } else {
            // call me again
            window.localStorage.setItem("gpSessionExpired", true);
            window.__firstLoadMe = false;
            window.__firstLoadMeParams = [];
            store.dispatch("accountWhoAmI");
          }
        };

        if(window.___gemMeInfo){
          // trường hợp đã load xong api me ở index.html
          callbackAPIMe(window.___gemMeInfo);
        }else{
          // chưa kịp loading xong thì lưu vào callback
          window.__callbackWhoAmI = callbackAPIMe;
        }
        return;

      } else{
        res = await Api.base.get(ApiUrl.base.account.whoAmI, {
          params: params
        });

        if (res.data) {

          store.commit(MUTATION.ACCOUNT_ATTACH, res.data.data);

          if (onSuccess) onSuccess(res.data);
        } else {
          throw res;
        }
      }




    } catch (error) {
      if (onError) onError(error);
    }
    state.status.loading = false;
  },
  [ACTION.ACCOUNT_SETTINGS]: async (store) => {
    return new Promise(async (resolve, reject) => {
      const state = store.state;
      try {
        state.status.loading = true;
        let params = {
          "scriptInjector": true,
        };

        const res = await Api.base.get(ApiUrl.base.account.whoAmI, {params: params});

        if (!res.data) throw res;
        store.commit(MUTATION.ACCOUNT_ATTACH, res.data.data);
        resolve(res.data);

      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        reject(error);
      }
      state.status.loading = false;
    });
  },
  [ACTION.ACCOUNT_AGENCY_LOGIN]: async (store, { credential, onSuccess, onError }) => {
    let { email, password } = credential;
    const state = store.state;
    state.status.loading = true;
    try {
      let _method = process.env.NODE_ENV == "development" ? "get" : "post";
      let res = await Api.base[_method](ApiUrl.base.agency.login, {
        email,
        password
      });
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      if (res.data.status) {
        // state.logged = true;
        state.status.success = true;
        if (onSuccess && typeof onSuccess == "function") {
          onSuccess(res);
        }
      } else {
        throw res;
      }
    } catch (error) {
      state.status.error = true;
      if (onError && typeof onError == "function") {
        onError(error);
      }
    }
    setTimeout(() => {
      state.status.error = false;
      state.status.success = false;
    }, 1500);
    state.status.loading = false;
  },
  [ACTION.ACCOUNT_UNLINK_AGENCY]: store => {
    return new Promise(async (resolve, reject) => {
      store.commit(MUTATION.ACCOUNT_UNLINK_STATUS, { loading: true });
      try {
        let res = await Api.base.get(ApiUrl.base.account.unlinkAgency);
        if (res.data && res.data.status) {
          store.commit(MUTATION.ACCOUNT_UNLINK_STATUS, { success: true });
          store.commit(MUTATION.ACCOUNT_REMOVE_AGENCY_LOGO);
          setTimeout(() => {
            store.commit(MUTATION.ACCOUNT_UNLINK_STATUS, { success: false });
            resolve(res);
          }, 2000);
        } else {
          throw res.data;
        }
      } catch (err) {
        store.commit(MUTATION.ACCOUNT_UNLINK_STATUS, { error: true });
        setTimeout(() => {
          store.commit(MUTATION.ACCOUNT_UNLINK_STATUS, { error: false });
          reject(err);
        }, 2000);
      }
    });
  },
  [ACTION.ACCOUNT_GET_GOOGLE_AUTH]: (store) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await Api.base.get(ApiUrl.base.analytic.auth);
        if (res.data && res.data.status == "success") {
          if (typeof res.data.url == "string") {
            resolve({
              authorized: false,
              url: res.data.url,
            })
          } else {
            resolve({
              authorized: true,
            });
            store.commit(MUTATION.ACCOUNT_UPDATE_GOOGLE_AUTH, true);
          }
        } else {
          throw res.data;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        reject(err);
      }
    });
  },
  [ACTION.ACCOUNT_DISCONNECT_GOOGLE_ANALYTIC]: (store) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await Api.base.post(ApiUrl.base.analytic.disconnect);
        if (res.data && res.data.status == "success") {
          resolve({
            authorized: true,
          });
          store.commit(MUTATION.ACCOUNT_UPDATE_GOOGLE_AUTH, false);
        } else {
          throw res.data;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        reject(err);
      }
    });
  },
  [ACTION.SYSTEM_SETTING_GETHELP]: async (store) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.get(ApiUrl.base.systemSetting.getHelp);
        const configs = res.data.configs;
        if (configs) {
          const dataStored = configs.map((data)=>{
            return {
              key:data.key,
              value: JSON.parse(data.value)
            }
          });
          store.commit(MUTATION.ACCOUNT_UPDATE_GETHELP_DATA, dataStored);
          resolve(dataStored);
        } else {
          throw res;
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  // eslint-disable-next-line no-unused-vars
  [ACTION.ACCOUNT_CHANGE_LANGUAGE]({state, dispatch, commit}, lang) {

    if (!lang) {
      lang = process.env.VUE_APP_I18N_LOCALE ?? "en";
    }

    loadLanguageAsync(lang).then(() => {
      Cookie.set(GEM_LANG_COOKIE_NAME, lang, 2592000); // equivalent to 30 days
    })
  },

  // eslint-disable-next-line no-unused-vars
  [ACTION.ACCOUNT_CANCEL_CHANGE_LANGUAGE]({state, dispatch, commit}) {
    if (!state.hideLanguage) {
      let lang = state.shopInfo.language;
      if (i18n.locale != lang) {
        loadLanguageAsync(lang).then(() => {
          Cookie.set(GEM_LANG_COOKIE_NAME, lang, 2592000); // equivalent to 30 days
        })
      }
    }
  },
  checkValidKey({state}, key) {
    if(state.shopInfo) {
      const shopInfo = state.shopInfo
      const isValid = checkKeyValid(key, shopInfo.shopifyDomain, shopInfo.globalConfigs)
      return isValid;
    }
    return false;
  },

  [ACTION.ACCOUNT_CLOSE_TRIAL_SURVEY](store, {data}) {
    Api.base.put(ApiUrl.base.account.closeTrialSurvey, data)
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  },

  // [ACTION.ACCOUNT_FETCH_LANGUAGES](store, force = false) {
  //   return new Promise(async (resolve, reject) => {
  //     let state = store.state.language;
  //     if (state.loading) {
  //       reject();
  //       return;
  //     }
  //     if (state.fetched && !force) {
  //       resolve(state.list);
  //       return;
  //     }
  //     state.loading = true;
  //     try {
  //       const res = await Api.admin.get(ApiUrl.admin.crud)
  //       store.commit(MUTATION.ACCOUNT_FETCH_LANGUAGES, {
  //         list: res.data.items,
  //         reset: true
  //       });

  //       state.loading = false;
  //       if (!state.fetched) {
  //         state.fetched = true;
  //       }
  //       resolve(res.data.items);
  //     } catch (err) {
  //       // eslint-disable-next-line no-console
  //       console.error(err);
  //       state.loading = false;
  //       reject(err);
  //     }
  //   });
  // },

  [ACTION.ACCOUNT_UPDATE_SCRIPT_INJECTION]: async (store, data ) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await Api.base.post(ApiUrl.base.account.updateScriptInjector, data);
        if (res.data && res.data.headScriptStatus && res.data.bodyScriptStatus) {
          store.state.shopInfo.scriptInjector = {...data}
          resolve();
        } else {
          throw res.data;
        }
      } catch (err) {
        reject(err);
      }
    });
  },
  [ACTION.CONNECT_GEMPAGES_V7]: async (store, retry = 0) => {
    const shopV7 = await getShopV7Api()
    const shopIdNotfound = shopV7 && shopV7.shopID && shopV7.shopID != "0"
    const userNotExist = shopV7 && shopV7.code == 400417
    const shopNotConnected = shopV7 && shopV7.status != 'CONNECTED'
    if (shopIdNotfound && !userNotExist) {
      store.commit(MUTATION.SET_INSTANT_SHOP_ID, shopV7.shopID);
      store.commit(MUTATION.SET_INSTANT_SHOP_TOKEN, shopV7.token);
      if (shopNotConnected) {
        await connectPlatformV7();
      }
    } else if (retry < 3){
      // auto init gempages 7
      await initGemPages('GEMPAGESV7');
      await this.connectGemPagesV7(retry+1);
    }
  },
};

export default actions;
